/** Matches Organisation policy InfoBox accent (PolicyCreation, Product). */
export const ORG_ONBOARDING_INFO_COLOR = '#f1c400';

export const SUBSCRIPTION_KEY_PLACEHOLDER = 'XXXX-XXXX-XXXX-XXXX';

export const ONBOARDING_CURRENCIES = [
  { label: 'AUD - Australian Dollar', value: 'AUD' },
  { label: 'NZD - New Zealand Dollar', value: 'NZD' },
  { label: 'USD - United States Dollar', value: 'USD' },
  { label: 'GBP - British Pound', value: 'GBP' },
];
